export default {
  GET_10_DAY_HISTORY_REQUESTED: 'GET_10_DAY_HISTORY_REQUESTED',
  GET_10_DAY_HISTORY_SUCCEEDED: 'GET_10_DAY_HISTORY_SUCCEEDED',
  GET_10_DAY_HISTORY_FAILED: 'GET_10_DAY_HISTORY_FAILED',

  GET_CREATIVES_REPORT_REQUESTED: 'GET_CREATIVES_REPORT_REQUESTED',
  GET_CREATIVES_REPORT_SUCCEEDED: 'GET_CREATIVES_REPORT_SUCCEEDED',
  GET_CREATIVES_REPORT_FAILED: 'GET_CREATIVES_REPORT_FAILED',

  GET_CREATIVE_REQUESTED: 'GET_CREATIVE_REQUESTED',
  GET_CREATIVE_SUCCEEDED: 'GET_CREATIVE_SUCCEEDED',
  GET_CREATIVE_FAILED: 'GET_CREATIVE_FAILED',
  GET_TEARSHEET_REQUESTED: 'GET_TEARSHEET_REQUESTED',
  GET_TEARSHEET_SUCCEEDED: 'GET_TEARSHEET_SUCCEEDED',
  GET_TEARSHEET_FAILED: 'GET_TEARSHEET_FAILED',

  GET_DISCREPANCY_CREATIVES_REQUESTED: 'GET_DISCREPANCY_CREATIVES_REQUESTED',
  GET_DISCREPANCY_CREATIVES_SUCCEEDED: 'GET_DISCREPANCY_CREATIVES_SUCCEEDED',
  GET_DISCREPANCY_CREATIVES_FAILED: 'GET_DISCREPANCY_CREATIVES_FAILED',
}
